export default __webpack_public_path__ + "static/media/IMG_0031_4_11zon.17858289.jpg";